import ReportRoute from './ReportRoute';

export default {
  name: 'Reports',
  location: '/reports',
  component: ReportRoute,
};
